import React, { PropTypes } from 'react';

const PeopleListItem = (props) => {
  const { title, isLast } = props;
  return (
    <li className="slash-separated__list__item">{title}{isLast ? '.' : ' /'}</li>
  );
};

export default PeopleListItem;

PeopleListItem.propTypes = {
  title: PropTypes.string.isRequired,
  isLast: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/people/PeopleListItem.js